import { useEffect, useMemo, useState } from 'react'

const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']

const breakpointValues = breakpoints.map((breakpoint) => {
  return getComputedStyle(document.documentElement).getPropertyValue(
    `--bs-breakpoint-${breakpoint}`
  )
})

const breakpointValuesMap = breakpoints.reduce(
  (acc, breakpoint, index) => {
    acc[breakpoint] = breakpointValues[index] ?? '0'
    return acc
  },
  {} as Record<string, string>
)

export default function useBreakpoint(breakpoint: string) {
  const mediaQuery = useMemo(
    () => window.matchMedia(`(min-width: ${breakpointValuesMap[breakpoint]})`),
    [breakpoint]
  )

  const [matches, setMatches] = useState(mediaQuery.matches)

  useEffect(() => {
    const listener = () => {
      setMatches(mediaQuery.matches)
    }
    window.addEventListener('resize', listener)
    return () => {
      window.removeEventListener('resize', listener)
    }
  }, [mediaQuery])

  return matches
}
